import React from 'react';
import { Stack, Typography } from '@mui/material';
import { IStringValue } from './interfaces';

export const StringValue: React.FC<IStringValue> = ({
  label,
  value,
}): JSX.Element => {
  return (
    <Stack>
      <Typography
        variant="body1"
        fontWeight="bold"
        fontSize=".9rem"
        sx={{
          m: 0,
        }}
      >
        {label}
      </Typography>
      <Typography variant="body1" fontSize=".9rem">
        {value}
      </Typography>
    </Stack>
  );
};
